import { MarketplaceSubGroup } from "@shared/types";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import GroupCard from "features/newMarketplace/GroupCard";
import Col from "antd/es/col";
import Row from "antd/es/row";
import useNumCardsInRow from "utils/hooks/useNumCardsInRow";
import { ReactNode } from "react";
import styled, { useTheme } from "styled-components";
import GroupCardSkeleton from "features/newMarketplace/NewLook/GroupCardSkeleton.tsx";
import Panel from "common/NewLook/Panel.tsx";

interface GroupsCardsProps {
  groups: MarketplaceSubGroup[];
  loading?: boolean;
  openScoreModal?: (group: MarketplaceSubGroup) => void;
  emptyState?: ReactNode;
}

const GroupsCards = ({
  groups,
  loading,
  openScoreModal,
  emptyState,
}: GroupsCardsProps) => {
  const numCardsInRow = useNumCardsInRow(undefined, [750, 1300]);
  const { isNewLook } = useTheme();

  if (isNewLook) {
    if (!groups.length && !loading)
      return <Panel flush={true}>{emptyState}</Panel>;
    return (
      <NewLookGrid aria-busy={(loading && !groups.length) || undefined}>
        {groups.length
          ? groups.map((group, index) => (
              <GroupCard
                key={group.group_id}
                group={group}
                index={index}
                openScoreModal={openScoreModal}
              />
            ))
          : [0, 1, 2].map((index) => <GroupCardSkeleton key={index} />)}
      </NewLookGrid>
    );
  }

  return (
    <LoadingSpinnerOverlay isLoading={loading}>
      {!groups.length && !loading ? (
        emptyState
      ) : (
        <Row gutter={[16, 16]}>
          {groups.map((group, index) => {
            return (
              <Col
                span={24 / numCardsInRow}
                style={{ width: "100%" }}
                key={group.group_id}
              >
                <GroupCard
                  key={group.group_id}
                  group={group}
                  index={index}
                  openScoreModal={openScoreModal}
                />
              </Col>
            );
          })}
        </Row>
      )}
    </LoadingSpinnerOverlay>
  );
};

export default GroupsCards;

const NewLookGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
`;
